import "core-js/modules/es.array.push.js";
import { useRouter, useRoute } from 'vue-router';
import { ref, computed, onMounted, nextTick } from 'vue';
import { useStore } from 'vuex';
import { promoteUrl } from "@/utils/url";
import lottie from "lottie-web";
import { find } from "lodash-es";
export default {
  name: 'tabbarH5',
  setup() {
    const router = useRouter();
    const route = useRoute();
    const store = useStore();

    // lottie icon
    let animDom = {
      'anim1': ref(null),
      'anim2': ref(null),
      'anim3': ref(null),
      'anim4': ref(null)
    };
    let animLottie = {
      'anim1': null,
      'anim2': null,
      'anim3': null,
      'anim4': null
    };

    // 2023 新春裝飾
    const inNewYear2023 = computed(() => store.state.common.inNewYear2023);
    const navs = computed(() => {
      let inNewYear2023 = store.state.common.inNewYear2023;
      const data = inNewYear2023 ? [
        // 改成lottie後換皮需重構邏輯
      ] : [{
        title: '首页',
        iconDefault: require('@/assets/h5/icons/ic-tabbar-1@3x.png'),
        iconActive: true,
        refIndex: 1,
        refName: 'anim1',
        routerName: 'home',
        aHref: '',
        requireLogin: false,
        width: 29,
        height: 29
      }, {
        title: '发现',
        iconDefault: require('@/assets/h5/icons/ic-tabbar-2@3x.png'),
        iconActive: false,
        refIndex: 2,
        refName: 'anim2',
        routerName: '',
        aHref: '/plugin.php?id=jyjbwl:mission&mobile=2',
        requireLogin: false,
        width: 26,
        height: 29
      }, {
        title: '',
        iconDefault: require('@/assets/h5/icons/ic-tabbar-3@3x.png'),
        iconActive: null,
        routerName: '',
        aHref: '/forum.php?mod=post&action=newthread&fid=56&newpost=1&referer=' + encodeURIComponent(document.URL),
        requireLogin: true,
        width: 54,
        height: 54,
        isShare: true
      }, {
        title: '排行榜',
        iconDefault: require('@/assets/h5/icons/ic-tabbar-4@3x.png'),
        iconActive: true,
        refIndex: 3,
        refName: 'anim3',
        routerName: 'ranking-betking',
        routerMetaTabKey: 'ranking',
        // aHref: '/ranking.php?mod=betking',
        aHref: '',
        requireLogin: false,
        width: 31,
        height: 29
      }, {
        title: '我的',
        iconDefault: require('@/assets/h5/icons/ic-tabbar-5@3x.png'),
        iconActive: true,
        refIndex: 4,
        refName: 'anim4',
        routerName: 'space',
        routerParams: {
          userId: store.getters['user/userId']
        },
        // aHref: '/home.php?mod=space&do=profile&mycenter=1&mobile=2',
        aHref: '',
        requireLogin: true,
        width: 28,
        height: 29
      }];
      return data.map(el => {
        var _route$meta;
        return {
          ...el,
          isActive: el.routerName === route.name || !!el.routerMetaTabKey && el.routerMetaTabKey === ((_route$meta = route.meta) === null || _route$meta === void 0 ? void 0 : _route$meta.tabbarKey) || (el.aHref ? window.location.href.indexOf(el.aHref) > -1 : false)
        };
      });
    });
    const isLogin = computed(() => store.state.user.isLogin);
    onMounted(() => {
      nextTick(() => {
        lottieInit();
      });
    });
    let lottieInit = () => {
      var _find;
      animLottie.anim1 = lottie.loadAnimation({
        container: animDom.anim1.value[0],
        renderer: 'svg',
        loop: false,
        autoplay: false,
        animationData: require('@/assets/lottie/tabbar/home.json')
      });
      animLottie.anim2 = lottie.loadAnimation({
        container: animDom.anim2.value[0],
        renderer: 'svg',
        loop: false,
        autoplay: false,
        animationData: require('@/assets/lottie/tabbar/discover.json')
      });
      animLottie.anim3 = lottie.loadAnimation({
        container: animDom.anim3.value[0],
        renderer: 'svg',
        loop: false,
        autoplay: false,
        animationData: require('@/assets/lottie/tabbar/rank.json')
      });
      animLottie.anim4 = lottie.loadAnimation({
        container: animDom.anim4.value[0],
        renderer: 'svg',
        loop: false,
        autoplay: false,
        animationData: require('@/assets/lottie/tabbar/my.json')
      });

      // 當前route icon撥放
      let lottieKey = (_find = find(navs.value, o => o.isActive)) === null || _find === void 0 ? void 0 : _find.refIndex;
      if (lottieKey) {
        animLottie['anim' + lottieKey].goToAndPlay(1, true);
      }
    };
    function linkTo(index) {
      const {
        routerName,
        aHref,
        requireLogin,
        routerParams
      } = navs.value[index];
      // 验证登入
      if (requireLogin && !isLogin.value) {
        store.dispatch('common/showLoginBox');
        return;
      }
      // 跳转
      if (routerName) router.push({
        name: routerName,
        params: routerParams || {}
      });else if (aHref) {
        // 因为怕有延迟，所以添加 loading 来防呆
        store.dispatch('common/handleLoading', true);
        store.dispatch("common/closeRedirectLoadingInterval");
        location.href = promoteUrl() + aHref;
      }
    }
    let clickTab = (idx, moveNow) => {
      for (let i = 1; i <= 4; i++) {
        if (i === idx && moveNow) {
          animLottie['anim' + i].goToAndPlay(1, true);
          animDom['anim' + i].value[0].parentNode.classList.add("active");
        } else {
          animLottie['anim' + i].goToAndStop(1, true);
          animDom['anim' + i].value[0].parentNode.classList.remove("active");
        }
      }
    };
    return {
      ...animDom,
      navs,
      inNewYear2023,
      linkTo,
      clickTab
    };
  }
};